export default function ButtonModify({ active = false, onClick, children = 'Modificar' }) {
  return (
    <button
      type="button"
      className="flex items-center justify-center rounded-full font-medium cursor-pointer border-none active:scale-[0.98] transition-colors duration-200 ease-out"
      style={{
        fontSize: '13px',
        height: '40px',
        padding: '0 16px',
        backgroundColor: active ? '#ffffff' : 'rgba(255, 255, 255, 0.06)',
        color: active ? '#000000' : 'rgba(255, 255, 255, 0.85)',
        fontFamily: '"Public Sans", sans-serif',
        letterSpacing: '-0.01em',
      }}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
